// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__21ppj","footer":"ModalFilter_footer__2sYBw"};